<template>
<div>
    <section>
        <div v-if="loading" class="content content-centered">
            <pulse-loader></pulse-loader>
        </div>
        <div v-show="!loading" class="content">
            <div class="box">
                <div class="box-body">
                    <div class="row">
                        <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
                            <div class="alert" :class="'alert-' + flashType">{{ flashMessage }}</div>
                        </div>
                    </div>
                    <div id="details">
                        <div class="col-sm-12 text-right" v-permission.if="[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD]">
                            <button class="btn btn-danger mr-5" type="button" @click="deleteRouteModal">Delete Route</button>
                        </div>
                        <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
                            <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.name)">
                                        <label>Name</label>
                                        <input type="text" name="name" class="form-control" required v-model.lazy="tripRoute.name" placeholder="name">
                                        <field-messages name="name" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Name is a required field</div>
                                             <!-- <div slot="pattern">Registration no is invalid</div>
                                            <div slot="minlength">Minimum length of registration no is 10 character</div> -->
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.approxDistance)">
                                        <label>Approx. Distance(km) </label>
                                        <input type="number"  name="approxDistance" class="form-control" required v-model.lazy="tripRoute.approxDistance" placeholder="Approx. Distance">
                                        <field-messages name="approxDistance" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Approx. Distance is a required field</div>
                                            <!-- <div slot="pattern">Capacity is invalid</div>
                                            <div slot="min">Minimum 100 kg Capacity</div>
                                            <div slot="max">Maximum 30000 kg Capacity</div> -->
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.approxTime)">
                                        <label>Approx. Time (in Min)</label>
                                        <input type="number" max="2880" name="approxTime" class="form-control" required v-model.lazy="tripRoute.approxTime" placeholder="Approx. Time">
                                        <field-messages name="approxTime" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Approx. Time is a required field</div>
                                            <div slot="max">Maximum Time for a Trip is 2 days</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.status)">
                                        <label>Status</label>
                                        <select required v-model="tripRoute.status" name="status" class="form-control">
                                            <option value="active">Active</option>
                                            <option value="inactive">Inactive</option>
                                        </select>
                                        <field-messages name="status" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Status is a required field</div>
                                            <div slot="pattern">Status date is invalid</div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group" :class="fieldClassName(formstate.reportAssessment)">
                                        <label>Report Assessment</label>
                                        <input type="file" id="file" class="form-control" ref="reportAssesssment" v-on:change="onFilechanged"/>
                                        <field-messages name="reportAssessment" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Please upload less than 3mb picture</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.region)">
                                        <label>Geographical Area</label>
                                        <select v-model="tripRoute.region" required name="region" class="form-control">
                                            <option disabled>Select G.A</option>
                                            <option v-for="(item,index) in region_list" :key="index" :value="item.key">
                                                {{item.value}}
                                            </option>
                                        </select>
                                        <field-messages name="region" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Geographical Area is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.startSite)">
                                        <label>Start Location</label>
                                        <select v-model="tripRoute.startSite" required name="startSite" class="form-control" @change="addLatLng">
                                            <option disabled>Select Location</option>
                                            <option v-for="(item,index) in start_site" :key="index" v-bind:value="item._id" v-bind:lat="item.latitude" v-bind:long="item.longitude" v-bind:startmessageMarker="item.siteName" >
                                                {{item.siteName}}
                                            </option>
                                        </select>
                                        <field-messages name="startSite" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Start Location is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.endSite)">
                                        <label>End Location</label>
                                        <select v-model="tripRoute.endSite" required name="endSite" class="form-control" @change="addEndLatLng">
                                            <option disabled>End Location</option>
                                            <option v-for="(item,index) in end_site" :key="index" v-bind:value="item._id" v-bind:endLat="item.latitude" v-bind:endLong="item.longitude" v-bind:endmessageMarker="item.siteName">
                                                {{item.siteName}}
                                            </option>
                                        </select>
                                        <field-messages name="endSite" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">End Location is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                            
                            <div class="col-md-12">
                                <legend class="col-md-12">Route Markers</legend>
                                <div class="col-sm-12">
                                    <div class="col-sm-3">
                                        <label>Latitude</label>
                                    </div>
                                    <div class="col-sm-3">
                                        <label>Longitude</label>
                                    </div>
                                    <div class="col-sm-4">
                                        <label>Message</label>
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <div v-for="(routes, r_id) in tripRoute.routeMarkers">
                                        <div class="col-sm-3">
                                            <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.latitude)">
                                                <input type="number" class="form-control" required v-model="routes.latitude" placeholder="68.654 N" pattern ="^-?([1-8]?[1-9]|[1-9]0)\.{1}\d{1,6}">
                                                <field-messages name="latitude" show="$touched || $submitted" class="form-control-feedback">
                                                    <div slot="required">Latitude is required</div>
                                                    <div slot="pattern">Invalid Input</div>
                                                </field-messages>
                                            </validate>
                                        </div>
                                        <div class="col-sm-3">
                                            <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.longitude)">
                                                <input type="number" class="form-control" required v-model="routes.longitude" placeholder="68.654 E" pattern ="^-?([1-8]?[1-9]|[1-9]0)\.{1}\d{1,6}">
                                                <field-messages name="longitude" show="$touched || $submitted" class="form-control-feedback">
                                                    <div slot="required">Longitude is required</div>
                                                    <div slot="pattern">Invalid Input</div>
                                                </field-messages>
                                            </validate>
                                        </div>
                                        <div class="col-sm-4 marker">
                                            <textarea row="1" class="form-control required" required v-model="routes.message" placeholder="Route Message" />
                                        </div>
                                            <i class="col-sm-1 fa fa-trash text-secondary" @click="remove(r_id)" v-if="(r_id > 0 && r_id < tripRoute.routeMarkers.length-1)"></i>
                                        
                                    </div>
                                    <i class="col-sm-1 btn addbtn " style="height:50px;width:75px" @click="add(r_id)"><h4>+</h4></i>
                                </div>
                            </div>
                        </vue-form>
                        <div class="col-sm-12 text-right">
                            <router-link :to="{ name: 'Route' }">
                                <button class="mr-5 btn btn-default" type="button">Cancel</button>
                            </router-link>
                            <button class="mr-4 btn gradientbt" type="submit" @click="updateRoute" :disabled="!(formstate.$dirty && formstate.$valid)">Update Route</button>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>


        <!-- <tr v-for="(routes, r_id) in routeMarker">
            <td><input type='text' v-model="routes.northMarker"><td>
            <td><input type="text" v-model="routes.eastMarker" /></td>
            <td><input type="text" v-model="routes.messageMarker"/></td>
            <i class="fa fa-trash text-danger" @click="remove(r_id)"></i>
            <i class="fa fa-plus-circle text-success" @click="add(r_id)"></i>
        </tr> -->
</div>
</template> 


<script>
import { formService, eventBus , tripRouteService} from '../../../services';
import { EVENTS } from '../../../config';
import { USER_ROLES } from '../../../config';
import swal from 'sweetalert2';
import {mapState} from 'vuex';
import axios from 'axios'
export default {
    name: 'RouteDetail',
    data () {
        return {
            USER_ROLES:USER_ROLES,
           loading: false,
            flash: false,
            flashType: null,
            flashMessage: '',
            EVENTS: EVENTS,
            formstate: {},
            region_list : {},
            region_managers : {},
            start_site : {},
            end_site :{},
            r_id : {},
            photo: '',
            tripRoute : {
                routeMarkers:[{
                    latitude:'',
                    longitude:'',
                    message:'Start Location',
                },
                {
                    latitude:'',
                    longitude:'',
                    message:'End Location',
                }],
                //reportAssessment:''
            }
        }
    },
    mounted: function() {
        this.getRegionList()
        this.getSalesManager()
        this.getSite()
        this.getRoute()
        

    },
    methods: {
        fieldClassName: formService.fieldClassName,
        addLatLng(event){
            this.lat = event.target.options[event.target.selectedIndex].getAttribute('lat');
            this.long = event.target.options[event.target.selectedIndex].getAttribute('long');
            this.tripRoute.routeMarkers.splice(0,1, { latitude: this.lat, longitude :this.long,message:event.target.options[event.target.selectedIndex].getAttribute('startmessageMarker')})
            console.log("this.tripRoute.routeMarkers",this.tripRoute.routeMarkers)
       },
       addEndLatLng(event){
            this.endLat = event.target.options[event.target.selectedIndex].getAttribute('endLat');
            this.endLong = event.target.options[event.target.selectedIndex].getAttribute('endLong');
            this.endmessageMarker = event.target.options[event.target.selectedIndex].getAttribute('endmessageMarker');
            this.tripRoute.routeMarkers.splice(this.tripRoute.routeMarkers.length-1,1, { latitude: this.endLat, longitude :this.endLong, message:event.target.options[event.target.selectedIndex].getAttribute('endmessageMarker')})
       },
        getRoute () {
            console.log("hiiiiiii")
            return this.$triprouteDataRepository.find(this.$route.params._id)
            .then((response) => {
                this.tripRoute = response.data;
            })
            .catch((error) => {
                this.$snotify.error('Route detail failed', 'Error!')
            })
        },
        add(index){
           let markerLength = this.tripRoute.routeMarkers.length
            this.tripRoute.routeMarkers.splice(markerLength-1, 0, {})
           console.log('added')
       },

        remove(index){
            console.log('remove function called')
           if(this.tripRoute.routeMarkers.length>1){
               this.tripRoute.routeMarkers.splice(index,1);
               console.log('removed')
           }
        },
        onFilechanged(event){
            this.photo = event.target.files[0];
            this.tripRoute.reportAssessment = event.target.files[0]['name']
        },
        getSite(){
            this.loading  = true;
            const params  = {}
            params.$limit = 0;
            let siteList = [];
            this.$siteDataRepository.list(params)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.docs) {
                        siteList =  res.data.docs;
                       
                    }
                    this.start_site = siteList;
                    this.end_site = siteList;
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('site.requestFunction-error:', error)
                    this.$snotify.error('Get site list failed', 'Error!')
                })

        },
        getRegionList() {
            this.loading  = true;
            const params  = {}
            params.$limit = 0;
            if(this.user.roleName == "GA Head"){
                params.regionManager = this.user._id;
            }
            let regionlist = [];
            this.$regionDataRepository.list(params)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.docs) {
                        regionlist =  res.data.docs.map((item)=> {
                            return {
                                key : item._id, 
                                value : item.name
                            }
                        })
                       
                    }
                    this.region_list = regionlist;
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('Region.requestFunction-error:', error)
                    this.$snotify.error('Get region list failed', 'Error!')
                })
        },
        getSalesManager() {
            this.loading  = true;
            const params  = {}
            params.$limit = 0;
            params.roleRank = 4;
            let regionManagerList = [];
            this.$userRepository.list(params)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.docs) {
                        regionManagerList =  res.data.docs.map((item)=> {
                            return {
                                key : item._id, 
                                value : item.firstName +' '+item.lastName
                            }
                        })
                       
                    }
                    this.region_managers = regionManagerList;
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('Region Manager.requestFunction-error:', error)
                    this.$snotify.error('Get region manager list failed', 'Error!')
                })
        },
        
        updateRoute () {
            this.loading = true;
            return tripRouteService.updatetripRoute(this.tripRoute)
            .then((response) => {
                let docId = response._id;
                this.uploadDocument(docId)
                this.loading = false
                this.flash = false
                this.$snotify.success('Route details updated!', 'Success!')
                this.$router.push('/routes')
            })
            .catch(error => {
                this.loading = false
                console.error('RouteCreate.createDevice-error:', error)
                this.$snotify.error('Add Route failed', 'Error!')
                if (error.data.message.includes('must be one of')) {
                    this.flash = true
                    this.flashType = 'error'
                    this.flashMessage = 'Route is not updated due to some error. Please try again!.'
                }
            })
        },
        uploadDocument(docId){
            let formData = new FormData();
            formData.append('file', this.photo);
            formData.append('model',"driver");
            formData.append("docId",docId)
                axios.post('fileUpload',
                    formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                ).then(res =>{
                    console.log(res)
                    console.log('SUCCESS!!');
                })
                .catch(function() {
                    console.log('FAILURE!!');
            });
        },
        deleteRouteModal () {
            swal({
                title: 'Are you sure?',
                text: 'This will permanently delete this Route!',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!',
            }).then((result) => {
                if (result.value) {
                    this.deleteRoute()
                }
            })
        },
        deleteRoute () {
            this.loading = true
            return this.$triprouteDataRepository.deleteOne(this.tripRoute._id)
            .then((response) => {
                this.loading = false;
                return swal(
                    'Deleted!',
                    'Route has been deleted.',
                    'success'
                )
            })
            .then((response) => {
                this.loading = false;
                this.$router.push('/routes')
            })
            .catch((error) => {
                this.loading = false;
                this.$snotify.error('Delete route failed', 'Error!')
            })
        },
        fieldClassName: function (field) {
            if(!field) {
                return '';
            }
            if((field.$touched || field.$submitted) && field.$valid) {
                return 'has-success';
            }
            if((field.$touched || field.$submitted) && field.$invalid) {
                return 'has-danger';
            }
        },
    
        formatDate(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;
            
            return [year, month, day].join('-');
            
        },
        created() {
        const promises = []
        this.loading = true
        promises.push(this.getRoute())
        Promise.all(promises)
            .then(() => {
                this.loading = false
                this.ready = true
            })
            .catch(() => {
                this.loading = false
            })
        }
    },
    computed:{
        ...mapState({
            user : state => state.auth.user,
        })
    }
}
</script>

<style scoped>
    .required-field > label::after , label::after {
        content: '*';
        color: red;
        margin-left: 0.25rem;
    }
    .form-control-feedback {
        font-weight: 100;
        color: red;
        position: initial;
        text-align: left;
        height: auto;
        width: auto;
    }
    .has-danger {
        color: red
    }
    .swal2-popup{
        font-size: 2rem !important;
    }
    .mt {
        margin-top: 7px;
    }    
    .fa {
            font-size: 35px;
            margin: 5px;
            margin-bottom: 5px;
        }

    .marker {
        margin-bottom: 20px;
    }
    .box-body {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
}
.gradientbt{
    background: #0F6940;
        color: white
}
.addbtn{
    background-color:  rgba(255, 132, 78);
       color: white
}
</style>

    




// WEBPACK FOOTER //
// RouteDetail.vue?4023850b